import { useQuery } from "@tanstack/react-query";
import { getAllAccountApiRequest } from "../../services";
import { useCommonStore } from "../../store";

export const useGetAllAccountApi = (reload?: any) => {
  const { data, isLoading } = useQuery({
    queryKey: ["all-account", reload],
    queryFn: () => getAllAccountApiRequest(),
    enabled: true,
  });
  return {
    allAccount: data,
    isLoading,
  };
};
